import org from './org';
import dictionary from './dictionary';
import dictionaryTree from './dictionaryTree';

export default {
    org,
    dictionary ,
    dictionaryTree
}